var map = {
	"./images/student-photo-line02.png": 401,
	"./images/student-photo-next.png": 402,
	"./images/student-photo-photo.png": 403,
	"./images/student-photo-prev.png": 404,
	"./images/student-photo-save.png": 405,
	"./images/student-photo-upload-field.png": 406,
	"./images/student-photo-upload.png": 407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;